module.exports = __webpack_public_path__ + "static/media/huoshishan_plant.0a311897.webp";